import React from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';
import Navbar from './Navbar';

function About() {
  return (
    <div className="font-sans text-slate-800 bg-slate-50 min-h-screen flex flex-col">
      <div className="sticky top-0 z-50 bg-white border-b border-slate-200/60 shadow-sm/50">
        <Navbar />
      </div>

      <main className="flex-1 w-full flex flex-col items-center py-20 px-6">
        <div className="max-w-4xl w-full bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
          {/* Hero/Header section within the card */}
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 py-16 px-12 text-center">
            <h1 className="text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-4">
              Our Mission
            </h1>
            <div className="h-1.5 w-20 bg-sky-500 mx-auto rounded-full"></div>
            <p className="mt-8 text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed">
              We empower homeowners with the same data and tools used by professionals to fight unfair property tax assessments.
            </p>
          </div>
          
          <div className="p-12 md:p-16 space-y-12">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-slate-900 leading-tight">Data Integrity Matters</h2>
                <p className="text-lg text-slate-600 leading-relaxed">
                  Founded by real estate veterans and data scientists, Casalytix was built to solve a single problem: the lack of transparency in property tax assessments. Every year, millions of homeowners overpay because they lack the comparable sales data and professional valuation evidence needed to win an appeal.
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100 italic text-slate-500 text-lg leading-relaxed shadow-inner">
                "Our goal isn't just to provide data—it's to provide the confidence you need to stand before a tax board and win."
              </div>
            </div>

            <div className="border-t border-slate-100 pt-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-8">What We Do</h2>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="space-y-3">
                  <div className="h-1 w-12 bg-sky-500 rounded-full"></div>
                  <h4 className="font-bold text-slate-900">Advanced Analytics</h4>
                  <p className="text-slate-600 text-sm">We process millions of property records to find the specific "gold-standard" comps for your home.</p>
                </div>
                <div className="space-y-3">
                  <div className="h-1 w-12 bg-sky-500 rounded-full"></div>
                  <h4 className="font-bold text-slate-900">AI-Powered Strategy</h4>
                  <p className="text-slate-600 text-sm">Our AI analyzes your specific market volume and price trends to architect a winning argument.</p>
                </div>
                <div className="space-y-3">
                  <div className="h-1 w-12 bg-sky-500 rounded-full"></div>
                  <h4 className="font-bold text-slate-900">Professional Reporting</h4>
                  <p className="text-slate-600 text-sm">We package your evidence into professional PDF reports that tax assessment offices respect.</p>
                </div>
              </div>
            </div>

            <div className="bg-sky-50 rounded-2xl p-10 mt-12 flex flex-col md:flex-row items-center justify-between gap-8">
              <div>
                <h3 className="text-2xl font-bold text-slate-900 mb-2">Ready to check your assessment?</h3>
                <p className="text-slate-600">It only takes 60 seconds to get your free diagnosis.</p>
              </div>
              <Link to="/signup" className="whitespace-nowrap px-8 py-4 rounded-full bg-sky-500 hover:bg-sky-600 text-white font-bold text-lg shadow-lg shadow-sky-500/25 transition-all hover:-translate-y-0.5">
                Start My Free Analysis
              </Link>
            </div>
          </div>
        </div>
      </main>

      <footer className="w-full bg-white py-12 border-t border-slate-200 mt-auto">
        <div className="max-w-6xl mx-auto px-6 text-center text-slate-500">
          <p>© {new Date().getFullYear()} Casalytix. All rights reserved. | <a href="/privacy-policy" className="hover:text-sky-500 transition-colors">Privacy Policy</a></p>
        </div>
      </footer>
    </div>
  );
}

export default About;